import React from "react";

import { PopupModal } from "components/modals/ModalBox";
import useButtonLoader from "hooks/useButtonLoader";
import { toastMessage } from "utils/toastMessage";

import { deleteProductTypeApi } from "services/product-management";

const DeleteProductType = ({
  deleteModal,
  selectedProductDetail,
  fetchProductList,
  closeModel,
}) => {
  const [bannerButtonLoader, setBannerButtonLoader] = useButtonLoader("Yes");

  const deleteBannerHandler = async () => {
    try {
      setBannerButtonLoader(true);
      const {
        data: { code, status, message },
      } = await deleteProductTypeApi(selectedProductDetail._id);
      if (status || code === 200) {
        // Remove the deleted category from the list
        fetchProductList();

        closeModel();
        toastMessage(message, "success", "Delete Product-Type");
      }
    } catch (e) {
      console.log("error:", e.error);
    } finally {
      setBannerButtonLoader(false);
    }
  };

  return (
    <>
      <PopupModal
        show={deleteModal}
        handleClose={closeModel}
        content="Are you sure you want to Delete this Product Type?"
        title="Delete Product Type"
        buttonLoader={bannerButtonLoader}
        action={deleteBannerHandler}
      />
    </>
  );
};

export default DeleteProductType;
